define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom-class",
	"dojo/dom-construct",
	"dojo/keys",
	"dijit/_TemplatedMixin",
	"dijit/_Widget",
	"dijit/_WidgetsInTemplateMixin",
	"dijit/form/Button",
	"csi",
	"csi/html",
	"csi/locale",
	"csi/widget/InlineSelect",
	"dojo/text!csi/templates/crumb.html"
], function(declare,lang,domClass,domConstruct,keys,_TemplatedMixin,_Widget,_WidgetsInTemplateMixin,Button,csi,html,locale,InlineSelect,template) {

	html.registerDataAttribute("DATA_CRUMB_TYPE", "crumb-type");

	return declare([_Widget, _TemplatedMixin, _WidgetsInTemplateMixin], {
		// base widget members
		templateString: template,

		// connection points
		arrowButton: null,
		linkNode: null,
		textNode: null,
		searchNode: null,
		statusNode: null,
		
		// String: display frozen or inactive indicators on breadcrumbs
		status: null,

		// Action: action used to search
		defAction: null,

		// String: link to node if it supports views (if current node, then set to empty)
		href: "",

		// InlineSelect: widget to handle context searches
		searchBox: null,

		// String: tooltip for search arrow
		searchTitle: "",

		// Store: data store for search
		store: null,

		// String: display name of node
		text: "",

		// String: node type for given url
		typeCrumb: "",

		// String: url to node in crumb
		urlCrumb: null,
		
		// boolean: whether this is breadcrumb of archive node
		isArchiveNode: false,

		onChange: function(/*String*/url) {
			// summary: extension point when new node is selected for navigation
		},

		onBlur: function() {
			// summary: extension point when crumb search is stopped
		},

		postMixInProperties: function() {
			// summary: resolve search action for tooltip
			if (this.defAction) {
				this.defAction.resolve();
				this.searchTitle = this.defAction.getDescription();
			}

			this.inherited(arguments);
		},

		postCreate: function() {
			// summary: determine if crumb is link or plain text
			this.inherited(arguments);

			// crumb can go from link to text, so only hide textNode
			html.setVisible(this.href && !this.isArchiveNode ? this.textNode : this.linkNode, false);

			if (this.defAction) {
				// if action exists, then allow context search by click on arrow
				this.connect(this.arrowButton, "onClick", this._onSearch);
			} else {
				// otherwise disable button
				this.arrowButton.set("disabled", true);
			}
		},

		getSearchBox: function() {
			// summary: create ComboBox for searching
			if (!this.searchBox) {
				this.searchBox = new InlineSelect({
					bOpenOnFocus: true,
					store: this.store,
					onBlur: lang.hitch(this, this._onBlur),
					onChange: lang.hitch(this, this._onChange),
					onInput: lang.hitch(this, this._onInput)
				}).placeAt(this.searchNode);
				this.searchBox.startup();
			}

			return this.searchBox;
		},

		/**
		 * Return true if status node overflows crumb node
		 * @return {boolean}
		 */
		overflowsStatus: function() {
			const {
				domNode,
				status,
				statusNode
			} = this;

			if (!status) {
				return false;
			}

			const right1 = domNode.getBoundingClientRect().right;
			const right2 = statusNode.domNode.getBoundingClientRect().right;
			return right2 > right1;
		},

		_onBlur: function() {
			// summary: end action if focus lost on select control
			this._setDropDownActive(false);
			this.onBlur();
		},

		_onChange: function(/*String*/value) {
			// summary: cache result in breadcrumb cache and go to that location
			var	url = this.getSearchBox().get("value");
			if (url && (url != this.urlCrumb)) {
				this.onChange(url);
			} else {
				this._onBlur();
			}
		},

		_onInput: function(/*Event*/evt) {
			// summary: handle keyboard navigation
			if (evt.keyCode == keys.ESCAPE) {
				setTimeout(lang.hitch(this, this._onBlur), 1);
			}
		},

		_onSearch: function(/*Event*/e) {
			// summary: start context search
			this._setDropDownActive(true);
		},

		/**
		 * Remove hover CSS when leaving link node
		 */
		_onTextOut: function() {
			this.domNode.classList.remove("csi-crumb-hover-link");
		},

		/**
		 * Add hover CSS when over link node
		 */
		_onTextOver: function() {
			this.domNode.classList.add("csi-crumb-hover-link");
		},

		_setDropDownActive: function(/*Boolean*/b) {
			// summary: show drop-down select box when active, otherwise hide and show link
			domClass.toggle(this.domNode, "crumbActive", b);

			if (b) {
				this.getSearchBox().focus();
			} else if (this.searchBox) {
				this.searchBox.reset();
			}
		},

		_setDisabledAttr: function(/*Boolean*/disabled) {
			// summary: forward to drop-down button
			if (this.defAction) {
				this.arrowButton.set("disabled", disabled);
			}
		},
		
		_setStatusAttr: function(/*String*/s) {
			const {domNode, statusNode} = this;
			this._set("status", s);
			statusNode.set("name","");
			statusNode.set("value", locale.capitalizeResource(s));
			domNode.classList.toggle("csi-crumb-with-status", !!s);
		},

		_setHrefAttr: function(/*String*/s) {
			// summary: set href for link to node
			this._set("href", s);
			this._setDropDownActive(false);
			if (!this.isArchiveNode) {
				html.setVisible(this.linkNode, !!s);
				html.setVisible(this.textNode, !s);
			}
		},

		_setTextAttr: function(/*String*/text) {
			// summary: set name of crumb
			this._set("text", text);
			this._updateTextAndTitle();
		},

		_setTypeCrumbAttr: function(/*String*/typeNode) {
			// summary:
			this._set("typeCrumb", typeNode);
			html.setDataAttribute(this.domNode, html.DATA_CRUMB_TYPE, typeNode);
			this._updateTextAndTitle();
		},
		
		_updateTextAndTitle: function() {
			// summary: return tooltip for node in trail based on type
			var typeTooltip = locale.localeResolver.getTypeResource(this.typeCrumb, locale.TYPE_TOOLTIP);
			var title = locale.type(this.typeCrumb) + (typeTooltip ? " - " + typeTooltip : "") + ": " + this.text;
			var domNode = this.href && !this.isArchiveNode ? this.linkNode : this.textNode;
			html.setInnerText(domNode, this.text, true);
			domNode.title = title;
		}
	});
});